module.exports = __webpack_public_path__ + "img/2267.9806ca81.gif";